export function base64ToBlobAuto(base64String: string): Blob {
  const extractedMime = extractMimeType(base64String);
  const mimeType = extractedMime || 'application/octet-stream';
  const base64Data = stripBase64Header(base64String);

  const byteCharacters = atob(base64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: mimeType });
}

export function extractMimeType(base64: string): string {
  const match = base64.match(/^data:(.+);base64,/);
  return match ? match[1] : 'application/octet-stream';
}

export function stripBase64Header(base64: string): string {
  return base64.split(',')[1] || base64;
}
